export enum SUGGESTION_TYPE {
  ORDER = 'ORD',
}

export enum COMMERCIAL_CHANNEL_CODE {
  ONE_CLICK = 'ONC',
}

export enum SEARCH_TYPE {
  DETAILS = 'details',
}

export enum PREFIX_TYPE {
  POD = 'P',
  JOBSITE = 'J',
}
